import type { Trip } from "@fairfleet/geotab";
import type { TripsProgress } from "@/hooks/trips/useTripsByDateRange";
import { DeviceCapError } from "@/utilities/error/DeviceCapError";
import { SEARCHES_PER_BATCH } from "@/utilities/query/fetchTripsComplete";

export type TripsLoadState =
  /** Final for this group filter: a retry would hit the same cap. */
  | { kind: "capError"; error: DeviceCapError }
  | { kind: "retryableError" }
  | { kind: "progress"; progress: TripsProgress }
  | { kind: "none" };

/**
 * What the trips grid shows above its rows. A single batch finishes quickly; only a load over
 * several batches (a whole group) gets a progress bar.
 */
export function tripsLoadState(
  trips: Trip[] | undefined,
  error: Error | null | undefined,
  progress: TripsProgress | undefined,
): TripsLoadState {
  if (error instanceof DeviceCapError) return { kind: "capError", error };
  if (error) return { kind: "retryableError" };
  if (!trips && progress && progress.total > SEARCHES_PER_BATCH && progress.done < progress.total) {
    return { kind: "progress", progress };
  }
  return { kind: "none" };
}
